import * as React from 'react';
import { translate } from 'react-i18next';
import * as moment from 'moment';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import * as c from 'models/constants';
import { ItemCardButtons } from 'components';
import { IItemCardProps, IItemCardButtonsProps } from 'models/itemcard';
import { ArticleStatus } from 'models/enums/statuses';
import { imgSrcAttributes } from 'helpers/common';
import { IAuthContext, INodeData } from 'models/common';
import { NodeType } from 'models/enums/nodetype/nodetype';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';

interface IProps extends IItemCardProps {
	item: IArticleListCard;
	t?: (key: string, options?: any) => string;
	context?: IAuthContext;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ArticleItemCardComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.goToCard = this.goToCard.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
	}

	public goToCard(e: any) {
		e.preventDefault();
		if (this.props.goToCard) {
			const entityIdObj: INodeData = JSON.parse(this.props.item.entityId);
			this.props.goToCard(entityIdObj.id, entityIdObj.type);
		}
	}

	public editItem(e: React.MouseEvent<HTMLElement>) {
		e.preventDefault();
		e.stopPropagation();

		if (this.props.editItem !== undefined) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.editItem(entityIdObj.id);
		}
	}

	public deleteItem(e: React.MouseEvent<HTMLElement>) {
		e.preventDefault();
		e.stopPropagation();

		if (this.props.deleteItem !== undefined) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.deleteItem('', entityIdObj.id);
		}
	}

	public likeItem() {
		try {
			this.props.likeItem(NodeType.Article, JSON.parse(this.props.item.entityId).id);
		} catch (e) {
			console.error(e);
		}
	}

	public unlikeItem() {
		try {
			this.props.unlikeItem(NodeType.Article, JSON.parse(this.props.item.entityId).id);
		} catch (e) {
			console.error(e);
		}
	}

	public render() {
		const { currentUserId } = this.props;
		const { name, picture, addedBy, addedDate, status, userId } = this.props.item;
		const { t } = this.props;

		const itemCardButtonsProps: IItemCardButtonsProps = {
			editItemWhite:
				this.props.editItem !== undefined && status !== ArticleStatus.Approved && currentUserId === userId
					? this.editItem
					: null,
			deleteItemWhite:
				this.props.editItem !== undefined && status !== ArticleStatus.Approved && currentUserId === userId
					? this.deleteItem
					: null,
		};

		return (
			<div className="articleItemCard commonItemCard">
				<a href="#" className="d-block" onClick={this.goToCard}>
					<figure className="image">
						<img {...imgSrcAttributes(picture)} />
						<figcaption>
							<h2 className="serif text-center">{name}</h2>
						</figcaption>
						<ItemCardButtons {...itemCardButtonsProps} />
						{!this.props.disableActions ? (
							<p className="StatusText">{currentUserId === userId ? t('CodeList_ArticleStatus_' + status) : null}</p>
						) : null}
					</figure>
				</a>
				<div className="below">
					{currentUserId == userId ? null : <p>{addedBy}</p>}
					<p className="muted">{moment(addedDate).fromNow()}</p>
				</div>
			</div>
		);
	}
}

const ArticleItemCard = withAuthContext(ArticleItemCardComponent);

export { ArticleItemCard };
